document.addEventListener('contextmenu', function(e) {
  if(process.env.REACT_APP_STAGE.trim()==="prod"){
   e.preventDefault()
  }
})

document.onkeydown = function(e) {
  if(process.env.REACT_APP_STAGE.trim()==="prod"){
  if (e.keyCode == 123) {
    return false
  }
  if (e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
    return false
  }
  if (e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
    return false
  }
  if (e.metaKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
    return false
  }
  if (e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
    return false
  }
  if (e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
    return false
  }
  if (e.metaKey && e.keyCode == 'C'.charCodeAt(0)) {
    return false
  }
  if (e.metaKey && e.keyCode == 'V'.charCodeAt(0)) {
    return false
  }
  if (e.metaKey && e.keyCode == 'X'.charCodeAt(0)) {
    return false
  }
  if (e.metaKey && e.keyCode == 'Z'.charCodeAt(0)) {
    return false
  }
  if (e.metaKey && e.keyCode == 'A'.charCodeAt(0)) {
    return false
  }
}
}
